import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadTouristRoutesItem,
  saveTouristRoutesItem,
  saveTouristRoutesItemAsDraft,
} from 'store/slices/touristRoutes/actions';
import {
  ITouristRoutesDraftItem,
  ITouristRoutesItem,
} from 'store/slices/touristRoutes/interfaces';
import { StatusesEnum } from 'constants/status';

import { TouristRoutesForm } from './components/TouristRoutesForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.touristRoutes);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { b2cUrl } = useAppSelector(state => state.configSlice);

  React.useEffect(() => {
    dispatch(loadTouristRoutesItem(id));
  }, []);

  const onFinish = (values: ITouristRoutesItem) => {
    setIsLoading(true);
    dispatch(saveTouristRoutesItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/touristRoutes');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: ITouristRoutesDraftItem) => {
    setIsLoading(true);
    dispatch(saveTouristRoutesItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/touristRoutes');
      })
      .catch(() => setIsLoading(false));
  };

  const getOgSiteName = () => {
    if (!item) return null;

    const sysName = item.sysName || '';
    const linkToB2C =
      item.lang === 'en'
        ? `${b2cUrl}/en/touristRoutes/${id}/${sysName}`
        : `${b2cUrl}/touristRoutes/${id}/${sysName}`;

    return linkToB2C;
  };

  const cancelButtonHandler = () => {
    navigate('/touristRoutes');
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === Number(id) ? (
        <TouristRoutesForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          initialValues={{
            ...mapValuesToForm(item),
            ogUrl: getOgSiteName(),
            ogSiteName: 'Посети Кавказ',
            ogType: 'routes',
          }}
        />
      ) : null}
    </MainLayout>
  );
};
